import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import { getLogs as getLogsSdk, getLog as getLogSdk } from '@sdk/Conectores/Logs';

//Action Types
export const Types = {
  GET_LOGS: 'GET_LOGS',
  GET_LOGS_SUCCESS: 'GET_LOGS_SUCCESS',
  GET_LOGS_ERROR: 'GET_LOGS_ERROR',

  GET_LOG: 'GET_LOG',
  GET_LOG_SUCCESS: 'GET_LOG_SUCCESS',
  GET_LOG_ERROR: 'GET_LOG_ERROR',

  RESET_LOGS: 'RESET_LOGS',
};

//Action Creators
export const getLogs = (idConfiguracao, page = 1) => ({ type: Types.GET_LOGS, idConfiguracao, page });
export const getLogsSuccess = (data) => ({ type: Types.GET_LOGS_SUCCESS, data });
export const getLogsError = (error) => ({ type: Types.GET_LOGS_ERROR, error });

export const getLog = (idConfiguracao, id, page = 1) => ({ type: Types.GET_LOG, idConfiguracao, id, page });
export const getLogSuccess = (data) => ({ type: Types.GET_LOG_SUCCESS, data });
export const getLogError = (error) => ({ type: Types.GET_LOG_ERROR, error });

export const reset = () => ({ type: Types.RESET_LOGS });

//saga

function* fetchGetLogs(action) {
  try {
    const { page, idConfiguracao } = action;
    const logs = yield call(getLogsSdk, idConfiguracao, page);
    yield put(getLogsSuccess(logs));
  } catch (err) {
    Notification.error(err.message);
    yield put(getLogsError(err));
  }
}

function* fetchGetLog(action) {
  try {
    const { idConfiguracao, id, page } = action;
    const log = yield call(getLogSdk, idConfiguracao, id, page);
    yield put(getLogSuccess(log));
  } catch (err) {
    Notification.error(err.message);
    yield put(getLogError(err));
  }
}

export const saga = [takeLatest(Types.GET_LOGS, fetchGetLogs), takeLatest(Types.GET_LOG, fetchGetLog)];

// Reducer
const initialState = Map({
  logs: List(),
  log: {},
  xTotalPage: 0,
  xCurrentPage: 0,

  loadingLogs: false,
  successLogs: false,
  errorLogs: false,
  hasMoreLogs: false,

  loadingLog: false,
  successLog: false,
  errorLog: false,
});

const handleGetLogs = (state, action) => {
  return state.set('loadingLogs', true).set('successLogs', false).set('errorLogs', false);
};

const handleGetLogsSuccess = (state, action) => {
  const { logs, xTotalPage, xCurrentPage } = action.data;
  let todosLogs = List([...state.get('logs').toArray(), ...logs]);
  return state
    .set('logs', todosLogs)
    .set('xTotalPage', xTotalPage)
    .set('xCurrentPage', xCurrentPage)
    .set('hasMoreLogs', xTotalPage !== xCurrentPage)
    .set('loadingLogs', false)
    .set('successLogs', true)
    .set('errorLogs', false);
};

const handleGetLogsError = (state, action) => {
  return state.set('loadingLogs', false).set('successLogs', false).set('errorLogs', action.error);
};

const handleGetLog = (state, action) => {
  return state.set('loadingLog', true).set('successLog', false).set('errorLog', false);
};

const handleGetLogSuccess = (state, action) => {
  const { data } = action;
  return state.set('log', data[0]).set('loadingLog', false).set('successLog', true).set('errorLog', false);
};

const handleGetLogError = (state, action) => {
  return state.set('loadingLog', false).set('successLog', false).set('errorLog', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_LOGS:
      return handleGetLogs(state, action);
    case Types.GET_LOGS_SUCCESS:
      return handleGetLogsSuccess(state, action);
    case Types.GET_LOGS_ERROR:
      return handleGetLogsError(state, action);

    case Types.GET_LOG:
      return handleGetLog(state, action);
    case Types.GET_LOG_SUCCESS:
      return handleGetLogSuccess(state, action);
    case Types.GET_LOG_ERROR:
      return handleGetLogError(state, action);

    case Types.RESET_LOGS:
      return handleReset(state, action);

    default:
      return state;
  }
}
